import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  CLEAR_LOGIN_ERROR,
  USER_OAUTH_NEEDS_PROFILE,
  REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILED,
  UPDATE_USER_WALLET_HISTORY,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { 
  ref, 
  get, 
  set, 
  update,
  onValue,
  off,
  push,
  child
} from "firebase/database";
import { onAuthStateChanged, signInWithCredential, signInWithPopup, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithCustomToken, createUserWithEmailAndPassword } from "firebase/auth";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import base64 from 'react-native-base64';
import AccessKey from '../other/AccessKey';

export const fetchUser = () => (dispatch) => {
  const { auth, config, singleUserRef } = firebase;

  console.log('🔍 fetchUser iniciado');
  
  dispatch({
    type: FETCH_USER,
    payload: null
  });
  
  onAuthStateChanged(auth, user => {
    console.log('👤 onAuthStateChanged:', user ? `Usuário ${user.uid}` : 'Nenhum usuário');
    
    if (user) {
      console.log('📊 Buscando dados do usuário no Database:', user.uid);

      let noProfileTimer = null;
      onValue(singleUserRef(user.uid), async snapshot => {
        console.log('📦 Snapshot recebido:', snapshot.exists());

        if (snapshot.val()) {
          if (noProfileTimer) { clearTimeout(noProfileTimer); noProfileTimer = null; }
          let profile = snapshot.val();
          console.log('👤 Perfil encontrado:', profile);

          profile.uid = user.uid;
          dispatch({
            type: FETCH_USER_SUCCESS,
            payload: profile
          });

        } else {
          console.log('❌ Perfil NÃO encontrado no Database para UID:', user.uid);
          // Usuário autenticado no Firebase Auth, mas SEM perfil em users/{uid}.
          // Pode ser a janela curta do cadastro (perfil ainda sendo gravado), por
          // isso aguardamos um pouco. Se continuar ausente, é uma conta órfã
          // (Auth sem perfil) — sinalizamos falha para o login NÃO ficar travado
          // em spinner infinito e o usuário receber feedback.
          if (!noProfileTimer) {
            noProfileTimer = setTimeout(() => {
              if (auth.currentUser && auth.currentUser.uid === user.uid) {
                // Login social de conta nova: o perfil ainda não existe DE PROPÓSITO
                // porque o usuário está completando o cadastro (CPF/RG) na tela Register.
                // Não tratamos como órfã enquanto essa flag estiver ativa.
                const authState = store.getState().auth;
                if (authState && authState.oauthNeedsProfile) { return; }
                const langData = store.getState().languagedata.defaultLanguage;
                dispatch({
                  type: FETCH_USER_FAILED,
                  payload: {
                    code: langData.auth_error,
                    message: langData.not_registred || 'Perfil não encontrado.'
                  }
                });
              }
            }, 4000);
          }
        }
      });
      
    } else {
      console.log('⚠️ Nenhum usuário autenticado');
      dispatch({
        type: FETCH_USER_FAILED,
        payload: { 
          code: store.getState().languagedata.defaultLanguage.auth_error, 
          message: store.getState().languagedata.defaultLanguage.not_logged_in 
        }
      });
    }
  });
};

export const validateReferer = async (referralId) => {
  const { database } = firebase;
  
  console.log('🔍 Validando referência:', referralId);
  
  try {
    const usersRef = ref(database, 'users');
    const snapshot = await get(usersRef);
    
    let referrerInfo = null;
    
    snapshot.forEach((childSnapshot) => {
      const user = childSnapshot.val();
      if (user.referralId === referralId) {
        referrerInfo = {
          ...user,
          uid: childSnapshot.key
        };
      }
    });
    
    if (referrerInfo) {
      console.log('✅ Referência válida encontrada:', referrerInfo.uid);
      return referrerInfo;
    } else {
      console.log('❌ Referência não encontrada');
      return { error: 'Referência não encontrada' };
    }
    
  } catch (error) {
    console.error('❌ Erro ao validar referência:', error);
    return { error: error.message };
  }
};  

export const checkUserExists = async (data) => {
  const { config, database } = firebase;

  const email = data.email ? String(data.email).toLowerCase() : null;
  const mobile = data.mobile || null;
  const cpf = data.cpf ? String(data.cpf).replace(/\D/g, '') : null;
  const rg = data.rg ? String(data.rg).replace(/\D/g, '') : null;
  const excludeUid = data.excludeUid || null;

  // Em desenvolvimento (somente React Native; no web __DEV__ não existe → typeof evita ReferenceError)
  const isDev = (typeof __DEV__ !== 'undefined') && __DEV__;
  if (isDev) {
    try {
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      let users = [];
      let conflicts = {};

      snapshot.forEach((childSnapshot) => {
        const user = childSnapshot.val();
        const uid = childSnapshot.key;
        if (excludeUid && uid === excludeUid) return;

        if (email && user.email && user.email.toLowerCase() === email) {
          users.push({ ...user, uid }); conflicts.email = true;
        }
        if (mobile && user.mobile === mobile) {
          users.push({ ...user, uid }); conflicts.mobile = true;
        }
        if (cpf && user.cpf && String(user.cpf).replace(/\D/g, '') === cpf) {
          users.push({ ...user, uid }); conflicts.cpf = true;
        }
        if (rg && user.rg && String(user.rg).replace(/\D/g, '') === rg) {
          users.push({ ...user, uid }); conflicts.rg = true;
        }
      });

      return { error: false, users, conflicts, exists: users.length > 0 };
    } catch (error) {
      console.error('❌ Erro na verificação local:', error);
      return { error: false, users: [], conflicts: {}, exists: false };
    }
  }

  // Produção: Cloud Function check_user_exists
  try {
    const projectId = config.projectId;
    const cfUrl = `https://us-central1-${projectId}.cloudfunctions.net/check_user_exists`;

    const response = await fetch(cfUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(projectId + ":" + AccessKey)
      },
      body: JSON.stringify({
        email,
        mobile,
        ...(cpf ? { cpf } : {}),
        ...(rg ? { rg } : {}),
        ...(excludeUid ? { excludeUid } : {})
      })
    });

    if (response.ok) {
      const result = await response.json();
      // Garante as chaves padrão mesmo se a CF antiga não devolver conflicts
      return { users: [], conflicts: {}, ...result };
    }
    console.warn('⚠️ Cloud Function retornou erro:', response.status);
    return { error: false, users: [], conflicts: {}, exists: false };
  } catch (error) {
    console.error('❌ Erro Cloud Function:', error.message);
    return { error: false, users: [], conflicts: {}, exists: false };
  }
};

// Reserva atômica de CPF/RG (índices unique_cpf / unique_rg) via Cloud Function.
// Também é usada pela edição de perfil. Retorna { success } ou { success:false, error }.
const requestUpdateUserProfile = async (uid, profile, excludeUid) => {
  const { config } = firebase;
  const projectId = config.projectId;
  const url = `https://us-central1-${projectId}.cloudfunctions.net/update_user_profile`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(projectId + ":" + AccessKey)
      },
      body: JSON.stringify({ uid, profile, ...(excludeUid ? { excludeUid } : {}) })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok || result.error) {
      return { success: false, error: result.error || `http_${response.status}` };
    }
    return { success: true };
  } catch (error) {
    return { success: false, error: 'network_error' };
  }
};

// Grava o perfil no RTDB e reserva CPF/RG (índices unique_cpf/unique_rg).
// Reaproveitado pelo fluxo normal de cadastro e pela recuperação de contas órfãs
// (conta no Auth que ficou sem perfil por uma gravação que falhou antes).
// allowDelete: no fluxo de email/senha, se a gravação falhar ou houver conflito de
// CPF/RG, a conta recém-criada no Auth é removida para não deixar órfã. No fluxo
// social (Google/Apple) a conta JÁ existe e é a identidade do usuário — não pode ser
// apagada; nesses casos passamos allowDelete:false e só devolvemos o erro.
const persistNewUserProfile = async (userCredential, regData, options = {}) => {
  const { allowDelete = true } = options;
  const { database } = firebase;
  const uid = userCredential.user.uid;

  // Normaliza CPF/RG para dígitos
  const cpfDigits = regData.cpf ? String(regData.cpf).replace(/\D/g, '') : '';
  const rgDigits = regData.rg ? String(regData.rg).replace(/\D/g, '') : '';

  const userProfile = {
    ...regData,
    uid: uid,
    createdAt: Date.now(),
    approved: regData.usertype === 'customer' ? true : false,
    profile_image: regData.profile_image || '',
    walletBalance: 0,
    pushToken: '',
    userPlatform: 'MOBILE'
  };

  // Remove campos sensíveis
  delete userProfile.password;
  delete userProfile.confirmpassword;

  // CPF/RG são gravados pela Cloud Function após a reserva atômica (evita órfãos/duplicatas)
  delete userProfile.cpf;
  delete userProfile.rg;

  // Garante que o token de autenticação do novo usuário já esteja propagado antes
  // de gravar o perfil. Escrever cedo demais pode ser rejeitado pelas regras do RTDB
  // (auth ainda null), deixando a conta no Auth SEM perfil → login trava no login.
  try { await userCredential.user.getIdToken(true); } catch (e) { /* ignore */ }

  // Salva no Realtime Database (sem CPF/RG ainda)
  try {
    await set(ref(database, `users/${uid}`), userProfile);
  } catch (writeErr) {
    // Não deixa conta órfã: se o perfil não pôde ser gravado, remove a conta
    // recém-criada no Auth para liberar o e-mail e permitir nova tentativa limpa.
    console.error('❌ Falha ao gravar perfil no signup, removendo conta órfã:', writeErr);
    if (allowDelete) { try { await userCredential.user.delete(); } catch (e) { /* ignore */ } }
    return { error: true, code: 'profile_write_failed', message: 'Falha ao salvar o perfil. Tente novamente.' };
  }

  // Reserva atômica de CPF/RG (índices unique_cpf/unique_rg) via Cloud Function.
  if (cpfDigits || rgDigits) {
    const claim = await requestUpdateUserProfile(uid, { cpf: cpfDigits, rg: rgDigits });
    if (claim.error === 'cpf_already_exists' || claim.error === 'rg_already_exists') {
      // Rollback: remove o nó (e o usuário recém-criado, no fluxo de email/senha).
      // No fluxo social mantemos a conta autenticada para o usuário corrigir o
      // CPF/RG e reenviar sem precisar logar de novo.
      try { await set(ref(database, `users/${uid}`), null); } catch (e) { /* ignore */ }
      if (allowDelete) { try { await userCredential.user.delete(); } catch (e) { /* ignore */ } }
      const langData = (store.getState().languagedata && store.getState().languagedata.defaultLanguage) || {};
      return {
        error: true,
        code: claim.error,
        message: langData[claim.error] || (claim.error === 'rg_already_exists'
          ? 'Este RG já está cadastrado em outra conta.'
          : 'Este CPF já está cadastrado em outra conta.')
      };
    }
    if (!claim.success) {
      // Erro transitório (rede/HTTP): grava CPF/RG direto no nó mesmo sem reservar o
      // índice — a verificação por varredura ainda protege e o índice é reforçado depois.
      try {
        await update(ref(database, `users/${uid}`), {
          cpf: cpfDigits || null,
          rg: rgDigits || null
        });
      } catch (e) { /* ignore */ }
    }
  }

  return { uid: uid, success: true, message: 'Usuário criado com sucesso' };
};

export const mainSignUp = async (regData) => {
  const { auth, database } = firebase;

  try {
    // 1. Cria no Firebase Authentication e 2-4. grava perfil + reserva CPF/RG
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      regData.email,
      regData.password
    );
    return await persistNewUserProfile(userCredential, regData);

  } catch (error) {
    console.error('❌ Erro no mainSignUp:', error.code, error.message);

    // Recuperação de conta órfã: o e-mail já existe no Auth, mas pode estar SEM
    // perfil (cadastro anterior que falhou ao gravar). Se a senha confere e não há
    // perfil, recriamos o perfil agora para destravar o login dessa conta.
    if (error.code === 'auth/email-already-in-use') {
      try {
        const cred = await signInWithEmailAndPassword(auth, regData.email, regData.password);
        const snap = await get(ref(database, `users/${cred.user.uid}`));
        if (!snap.exists()) {
          console.log('♻️ Conta órfã detectada — recriando perfil para', regData.email);
          return await persistNewUserProfile(cred, regData);
        }
        // Já existe perfil → e-mail realmente em uso por uma conta válida.
        return { error: true, code: 'auth/email-already-in-use', message: 'Este email já está em uso' };
      } catch (e) {
        // Senha não confere (conta de outra pessoa) ou outro erro → mensagem padrão.
        return { error: true, code: 'auth/email-already-in-use', message: 'Este email já está em uso' };
      }
    }

    let errorMessage = error.message;
    if (error.code === 'auth/weak-password') {
      errorMessage = 'A senha é muito fraca';
    } else if (error.code === 'auth/invalid-email') {
      errorMessage = 'Email inválido';
    } else if (error.code === 'auth/network-request-failed') {
      errorMessage = 'Erro de conexão. Verifique sua internet';
    }

    return { error: true, message: errorMessage, code: error.code };
  }
};

// Completa o cadastro de um usuário que entrou por Google/Apple. A conta JÁ existe
// no Firebase Auth (criada pelo signInWithCredential), mas sem perfil em users/{uid}
// porque o login social só entrega nome/email — faltam CPF/RG (obrigatórios).
// Grava o perfil no uid existente SEM criar nova conta e SEM exigir senha.
// Não apaga a conta em caso de conflito de CPF/RG (allowDelete:false): o usuário
// segue autenticado, corrige o dado e reenvia.
export const completeOAuthProfile = async (regData) => {
  const { auth } = firebase;
  const user = auth.currentUser;
  if (!user) {
    return { error: true, code: 'no_auth_user', message: 'Sessão expirada. Entre novamente com Google/Apple.' };
  }
  return await persistNewUserProfile({ user }, regData, { allowDelete: false });
};

// Usuário desistiu de completar o cadastro social. A conta no Auth foi criada pelo
// signInWithCredential mas está SEM perfil (órfã). Aqui APAGAMOS essa conta (não só
// signOut) e desanexamos o listener de perfil — senão uma nova tentativa com o mesmo
// Google/Apple reentra no mesmo uid sem perfil e trava em loop/crash.
export const cancelOAuthProfile = () => (dispatch) => {
  const { auth, singleUserRef } = firebase;
  const user = auth.currentUser;
  if (user) {
    // Para de ouvir users/{uid} para não vazar nem disparar callbacks após a saída.
    try { off(singleUserRef(user.uid)); } catch (e) { /* ignore */ }
    // Apaga a conta órfã; se falhar (ex.: requires-recent-login), ao menos faz signOut.
    user.delete().catch(() => { try { signOut(auth); } catch (e) { /* ignore */ } });
  } else {
    try { signOut(auth); } catch (e) { /* ignore */ }
  }
  dispatch({
    type: USER_SIGN_OUT,
    payload: null
  });
};

// Atualiza o perfil garantindo unicidade de CPF/RG (Cloud Function update_user_profile).
// Uso: await dispatch(updateProfileWithUniqueness(uid, { cpf, rg, ... }, excludeUid))
export const updateProfileWithUniqueness = (uid, profile, excludeUid) => async () => {
  return requestUpdateUserProfile(uid, profile, excludeUid);
};


export const updateProfileWithEmail = (profileData) => async (dispatch) => {
  const {
    config
  } = firebase;
  try{
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/update_user_email`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Basic " + base64.encode(config.projectId + ":" + AccessKey)
      },
      body: JSON.stringify(profileData)
    })
    const result = await response.json();
    if(result.error){ 
      return {success: false, error: result.error}
    }
  }catch(error){
    return {success: false, error: error}
  }
}


export const requestPhoneOtpDevice = (verificationId) => async (dispatch) => {
    dispatch({
      type: REQUEST_OTP_SUCCESS,
      payload: verificationId
    }); 
}

export const mobileSignIn = (verficationId, code, mobileInfo) => (dispatch) => {
  const {
    auth,
    mobileAuthCredential,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  signInWithCredential(auth, mobileAuthCredential(verficationId, code))
    .then(async (result) => {
      // No web (document existe) mantém o comportamento antigo — fetchUser cuida.
      if (typeof document !== 'undefined') { return; }
      // App mobile: o SMS é enviado a TODOS. Se a conta autenticada pelo telefone
      // ainda não tem perfil em users/{uid}, é um usuário NOVO — sinaliza para a tela
      // de login levar ao cadastro (completar perfil), reaproveitando o mesmo
      // mecanismo do login social (USER_OAUTH_NEEDS_PROFILE + completeOAuthProfile).
      // O guard do fetchUser (oauthNeedsProfile) evita marcar como conta órfã.
      try {
        const uid = result.user.uid;
        const snap = await get(ref(database, `users/${uid}`));
        if (!snap.exists()) {
          dispatch({
            type: USER_OAUTH_NEEDS_PROFILE,
            payload: {
              uid,
              authMethod: 'mobile',
              mobile: (mobileInfo && mobileInfo.mobile) || '',
              countryCode: (mobileInfo && mobileInfo.countryCode) || ''
            }
          });
        }
        // Se já existe perfil, onAuthStateChanged/fetchUser cuida da navegação.
      } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
    }).catch(error => {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
};

export const saveAddresses = async (uid, location, name) => {
  const { singleUserRef } = firebase;
  onValue(child(singleUserRef(uid), "savedAddresses"), (savedAdd) => {
    if (savedAdd.val()) {
      let addresses = savedAdd.val();
      let didNotMatch = true;
      for (let key in addresses) {
        let entry = addresses[key];
        if (entry.name == name ) {
          didNotMatch = false;
          update(child(singleUserRef(uid),"savedAddresses/" + key),{
            description: location.add,
            lat: location.lat,
            lng: location.lng,
            count: 1,
            name: name
          });
          break;
        }
      }
      if (didNotMatch) {
        push(child(singleUserRef(uid),"savedAddresses"),{
          description: location.add,
          lat: location.lat,
          lng: location.lng,
          count: 1,
          name: name
        });
      }
    } else {
      push(child(singleUserRef(uid),"savedAddresses"),{
        description: location.add,
        lat: location.lat,
        lng: location.lng,
        count: 1,
        name: name
      });
    }
  }, {onlyOnce: true});
};

export const googleLogin = (idToken, accessToken, oauthInfo) => (dispatch) => {

  const {
    auth,
    googleCredential,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  const credential = googleCredential(idToken, accessToken);
  signInWithCredential(auth, credential)
    .then(async (result) => {
      // Detecção de conta nova só no app mobile (React Native). No web (document
      // existe) o fluxo segue como antes — o fetchUser trata o erro de perfil ausente.
      if (typeof document !== 'undefined') { return; }
      // Conta nova via social: existe no Auth, mas ainda sem perfil (faltam CPF/RG).
      // Sinaliza para a tela de login redirecionar ao cadastro (completar perfil).
      try {
        const uid = result.user.uid;
        const snap = await get(ref(database, `users/${uid}`));
        if (!snap.exists()) {
          dispatch({
            type: USER_OAUTH_NEEDS_PROFILE,
            payload: {
              uid,
              email: result.user.email || (oauthInfo && oauthInfo.email) || '',
              firstName: (oauthInfo && oauthInfo.firstName) || '',
              lastName: (oauthInfo && oauthInfo.lastName) || ''
            }
          });
        }
        // Se já existe, o onAuthStateChanged/fetchUser cuida da navegação.
      } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
    })
    .catch(error => {
      console.log(error);
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
}

export const appleSignIn = (credentialData, oauthInfo) => (dispatch) => {

  const {
    auth,
    appleProvider,
    database
  } = firebase;

  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });
  if (credentialData) {
    const credential = appleProvider.credential(credentialData);
    signInWithCredential(auth, credential)
      .then(async (result) => {
        // Detecção de conta nova só no app mobile (React Native). No web (document
        // existe) o fluxo segue como antes — o fetchUser trata o perfil ausente.
        if (typeof document !== 'undefined') { return; }
        // Conta nova via social: existe no Auth, mas ainda sem perfil (faltam CPF/RG).
        // Sinaliza para a tela de login redirecionar ao cadastro (completar perfil).
        // Obs.: a Apple só entrega nome/email na PRIMEIRA autorização — exatamente o
        // caso de um usuário novo —, por isso usamos o oauthInfo aqui.
        try {
          const uid = result.user.uid;
          const snap = await get(ref(database, `users/${uid}`));
          if (!snap.exists()) {
            dispatch({
              type: USER_OAUTH_NEEDS_PROFILE,
              payload: {
                uid,
                email: result.user.email || (oauthInfo && oauthInfo.email) || '',
                firstName: (oauthInfo && oauthInfo.firstName) || '',
                lastName: (oauthInfo && oauthInfo.lastName) || ''
              }
            });
          }
          // Se já existe, o onAuthStateChanged/fetchUser cuida da navegação.
        } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
      })
      .catch((error) => {
        dispatch({
          type: USER_SIGN_IN_FAILED,
          payload: error
        });
      });
  } else {
    signInWithPopup(auth, appleProvider).then(function (result) {
      signInWithCredential(auth, result.credential)
        .then((user) => {
        //OnAuthStateChange takes care of Navigation
        })
        .catch(error => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        }
        );
    }).catch(function (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: error
      });
    });
  }
};

export const signOff = () => (dispatch) => {

  const {
    auth,
    singleUserRef,
    walletHistoryRef,
    userNotificationsRef
  } = firebase;

  const uid = auth.currentUser.uid;

  off(singleUserRef(uid));
  off(walletHistoryRef(uid));
  off(userNotificationsRef(uid));

  onValue(singleUserRef(uid), snapshot => {
      if(snapshot.val()){
        const profile = snapshot.val();
        if (profile && profile.usertype === 'driver') {
          update(singleUserRef(uid), {driverActiveStatus:false});
        }
        setTimeout(()=>{
          signOut(auth)
          .then(() => {
            dispatch({
              type: USER_SIGN_OUT,
              payload: null
            });
          })
          .catch(error => {
      
          });
        },2000)
      }
  },{onlyOnce: true});
};

export const updateProfile = (updateData) => async (dispatch) => {

  const {
    auth,
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef,
    facialImageRef
  } = firebase;

  const uid = auth.currentUser.uid;

  if (updateData.licenseImage) {
    await uploadBytesResumable(driverDocsRef(uid), updateData.licenseImage);
    updateData.licenseImage = await getDownloadURL(driverDocsRef(uid));
  }
  if (updateData.licenseImageBack) {
    await uploadBytesResumable(driverDocsRefBack(uid),updateData.licenseImageBack);
    updateData.licenseImageBack = await getDownloadURL(driverDocsRefBack(uid));
  }
  if (updateData.verifyIdImage) {
    await uploadBytesResumable(verifyIdImageRef(uid), updateData.verifyIdImage);
    updateData.verifyIdImage = await getDownloadURL(verifyIdImageRef(uid));
  }
  if (updateData.facialImage) {
    await uploadBytesResumable(facialImageRef(uid), updateData.facialImage);
    updateData.facialImage = await getDownloadURL(facialImageRef(uid));
    updateData.facialStatus = 'pending';
    updateData.facialUpdatedAt = new Date().getTime();
    updateData.facialRejectionReason = null;
  }

  update(singleUserRef(uid), updateData);
};


export const updateProfileImage = (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  uploadBytesResumable( profileImageRef(uid), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(profileImageRef(uid))
  }).then((url) => {
    update(singleUserRef(uid), {
      profile_image: url
    });
  })
};

export const updateWebProfileImage = async (imageBlob) => {

  const {
    auth,
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = auth.currentUser.uid;

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};
export const updateCustomerProfileImage = async (imageBlob, id) => {

  const {
    singleUserRef,
    profileImageRef
  } = firebase;

  const uid = id

  await uploadBytesResumable(profileImageRef(uid), imageBlob);
  let image = await getDownloadURL(profileImageRef(uid));
  update(singleUserRef(uid), {profile_image: image});

};

export const updatePushToken = (token, platform)  => {

  const {
    auth,
    singleUserRef,
  } = firebase;

  const uid = auth.currentUser.uid;

  update(singleUserRef(uid), {
    pushToken: token,
    userPlatform: platform
  });
};

export const clearLoginError = () => (dispatch) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const fetchWalletHistory = () => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = auth.currentUser.uid;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }
  });
};
export const fetchUserWalletHistory = (userId) => (dispatch) => {
  const {
    auth,
    walletHistoryRef
  } = firebase;

  const uid = userId;

  onValue(walletHistoryRef(uid) , snapshot => {
    const data = snapshot.val(); 
    if(data){
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: arr.reverse()
      });
    }else{
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload:[]
      });
    }
  });
};

export const sendResetMail = (email) => async (dispatch) => {
  const {
    authRef
  } = firebase;

  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email
  });
  sendPasswordResetEmail(authRef(), email).then(function() {
    console.log('Email send successfuly');
  }).catch(function (error) {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: {code: store.getState().languagedata.defaultLanguage.auth_error, message: store.getState().languagedata.defaultLanguage.not_registred }
      });
  });
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
  const { authRef } = firebase;
  
  console.log('🔍 DEBUG verifyEmailPassword chamada');
  console.log('📧 Email:', email);
  console.log('🔑 Senha:', pass ? 'Presente' : 'Faltando');

  // Dispatch que está começando o processo de login
  dispatch({
    type: USER_SIGN_IN,
    payload: { loading: true }
  });

  try {
    const userCredential = await signInWithEmailAndPassword(authRef(), email, pass);
    
    console.log('✅ Login Firebase bem-sucedido!');
    console.log('👤 User UID:', userCredential.user.uid);
    console.log('📧 User Email:', userCredential.user.email);
    
    // Dispatch de sucesso - se não houver, o Redux não sabe que login foi bem-sucedido
    dispatch({
      type: USER_SIGN_IN, // OU um tipo específico de sucesso se tiver
      payload: { 
        success: true,
        user: userCredential.user 
      }
    });
    
    // O onAuthStateChanged em fetchUser() vai cuidar do resto
    
  } catch (error) {
    console.error('❌ Erro no login:');
    console.error('   Código:', error.code);
    console.error('   Mensagem:', error.message);
    console.error('   Detalhes:', error);
    
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: error
    });
  }
}

export const requestMobileOtp = (mobile) => async (dispatch) => {
  const {
    config
  } = firebase;
  dispatch({
    type: REQUEST_OTP,
    payload: true
  }); 

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
  let url = `${host}/request_mobile_otp`;
  try{
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mobile: mobile })
    });
    const result = await response.json();
    if(result.success){
      dispatch({
        type: REQUEST_OTP_SUCCESS,
        payload: true
      });
    }else{
      dispatch({
        type: REQUEST_OTP_FAILED,
        payload: result.error
      });
    }
  }catch(error){
    console.log(error);
  }
}

export const verifyMobileOtp = (mobile, otp, mobileInfo) => async (dispatch) => {
  const {
    auth,
    config,
    database
  } = firebase;
  const body = {
    mobile: mobile,
    otp: otp
  };
  try{
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/verify_mobile_otp`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    const result = await response.json();
    if(result.token){
      signInWithCustomToken(auth,result.token)
        .then(async (cred) => {
          // No web (document existe) mantém o comportamento antigo — fetchUser cuida.
          if (typeof document !== 'undefined') { return; }
          // App mobile: o SMS é enviado a TODOS. Se a conta autenticada pelo telefone
          // ainda não tem perfil em users/{uid}, é um usuário NOVO — leva ao cadastro
          // (completar perfil) pelo mesmo mecanismo do login social.
          try {
            const uid = cred.user.uid;
            const snap = await get(ref(database, `users/${uid}`));
            if (!snap.exists()) {
              dispatch({
                type: USER_OAUTH_NEEDS_PROFILE,
                payload: {
                  uid,
                  authMethod: 'mobile',
                  mobile: (mobileInfo && mobileInfo.mobile) || '',
                  countryCode: (mobileInfo && mobileInfo.countryCode) || ''
                }
              });
            }
            // Se já existe perfil, onAuthStateChanged/fetchUser cuida da navegação.
          } catch (e) { /* fetchUser ainda cobre o caso de falha de leitura */ }
        })
        .catch((error) => {
          dispatch({
            type: USER_SIGN_IN_FAILED,
            payload: error
          });
        });
    }else{
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: result.error
      });
    }
  }catch(error){
    console.log(error);
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: error
    });
  }
}

export const updateAuthMobile = async ( mobile, otp) => {
  const {
    auth,
    config
  } = firebase;

  const uid = auth.currentUser.uid;
  const body = {
    uid: uid,
    mobile: mobile,
    otp: otp
  };

  const settings = store.getState().settingsdata.settings;
  let host = window && window.location && settings.CompanyWebsite === window.location.origin ? window.location.origin : `https://${config.projectId}.web.app`
  let url = `${host}/update_auth_mobile`;
  try{
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    })
    const result = await response.json();
    if(result.success){
      return {success: true}
    }else{
      return {success: false, error: result.error}
    }
  }catch(error){
    return {success: false, error: error}
  }
}
